import React from 'react';
import classes from './UserBlogItem.module.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { articleActions } from '../store/articleSlice';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

const UserBlogItem = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const editArticleHandler = (e) => {
    // there are two onclick event one one outer and other on inner dive so we to stop bubbling so it will execute inner first then outer.

    e.cancelBubble = true;
    e.stopPropagation();

    navigate(`./:${props.id}`);
  }

  const deleteArticleHandler = (e) => {
    e.cancelBubble = true;
    e.stopPropagation();
    dispatch(articleActions.deleteArticle(props.id));
    toast.error("Article Deleted Successfully");
  }

  const viewDetailedArticle = () => {
    navigate(`/:${props?.title.split(" ").join("-")}/:${props?.id}`)
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className={classes.blogItem} onClick={viewDetailedArticle}>
        <div className={classes.options}>
          <i onClick={editArticleHandler} class="fas fa-pen"></i>
          <i onClick={deleteArticleHandler} class="fas fa-trash"></i>
        </div>

        <h2>{props?.title}</h2>

        {props && <div className={classes.features}>
          {props &&
            <div className={classes.like}>
              <i class="fa-solid fa-hands-clapping"></i>
              <span>{props?.likesCount}</span>
            </div>
          }

          {props && <div className={classes.commentIcon}>
            <i class="fa-regular fa-comment"></i>
            <span>{props?.commentsCount}</span>
          </div>}

        </div>}

        <div className={classes.details}>
          <h3>{props?.author}</h3>
          <h3>{props?.date}</h3>
        </div>
        
        <div className={classes.description}>
          <p>{props?.plaintext?.substring(0, 400)}.................</p>
        </div>
      </div>
    </>
  )
}

export default UserBlogItem;